import React from 'react';

import { useIntl } from 'react-intl';

import { PopupSelect } from '@atlaskit/select/popup-select';
import {
	getOptionKey,
	RESULTS_SORT_FIELDS,
	type ResultsSortOptionKey,
	ResultsSortOptions,
	SORT_FIELD_KEY,
	SORT_ORDER,
} from '@atlassian/dynamic-cards-search-client/graphql/results-sort';

import { ProductKeys } from '../../../../../common/constants/products';
import { FilterButton } from '../../../../../common/ui/filters/filter-button';
import { useResultsSort, useSelectedProduct } from '../../../../../controllers/store';
import { messages } from './messages';

export const ResultsSort = (): React.JSX.Element | null => {
	const { formatMessage } = useIntl();
	const [selectedProduct] = useSelectedProduct();
	const [{ order, field }, { setResultsSort }] = useResultsSort();

	const handleSelectOption = (option: { label: string; value: ResultsSortOptionKey }) => {
		setResultsSort({
			order: RESULTS_SORT_FIELDS[option.value].order,
			field: RESULTS_SORT_FIELDS[option.value].field,
		});
	};

	if (selectedProduct !== ProductKeys.Confluence) {
		return null;
	}

	const selectedOptionKey = getOptionKey(field, order);

	const options = ResultsSortOptions.map((option) => ({
		label: formatMessage(messages[option.labelKey]),
		value: option.labelKey,
		isSelected: option.labelKey === selectedOptionKey,
	}));

	return (
		<PopupSelect
			label={formatMessage(messages.sortOptionsLabel)}
			blurInputOnSelect={false}
			tabSelectsValue={false}
			backspaceRemovesValue={false}
			hideSelectedOptions={false}
			controlShouldRenderValue={false}
			isClearable={false}
			maxMenuWidth="22rem"
			maxMenuHeight={400}
			menuPlacement="bottom"
			isOptionSelected={(option) => option.isSelected}
			onChange={(value) => value && handleSelectOption(value)}
			options={options}
			popperProps={{
				strategy: 'fixed',
				modifiers: [
					{ name: 'offset', options: { offset: [0, 8] } },
					{
						name: 'preventOverflow',
						enabled: false,
					},
				],
			}}
			target={({ isOpen, ...triggerProps }) => {
				const isSelected =
					isOpen || field !== SORT_FIELD_KEY.LAST_MODIFIED_DATE || order !== SORT_ORDER.DESC;
				return (
					<FilterButton
						isSelected={isSelected}
						otherProps={triggerProps}
						label={formatMessage(messages[RESULTS_SORT_FIELDS[selectedOptionKey].selectedLabelKey])}
						filterOrControlId={'sort'}
					/>
				);
			}}
		/>
	);
};
